module.exports = __webpack_public_path__ + "static/comp_back-12e4ff456c2c65c0e420191906dfb427.jpg";